import type { CSSProperties, ComponentType } from 'react'
import type { IconProps } from '@features/shared/icons/icons'
import { DatabaseIcon, FolderIcon } from '@features/shared/icons/icons'

interface SidebarDragChipProps {
  kind: 'table' | 'folder'
  label: string
  /** Its own icon instead of the kind's (a favorite's area's), or null for none. */
  icon?: ComponentType<IconProps> | null
  style?: CSSProperties
}

/**
 * The floating copy of a sidebar row that follows the pointer while it is
 * dragged: a row tall, so it sits exactly on the place it would drop into.
 */
export default function SidebarDragChip({ kind, label, icon, style }: SidebarDragChipProps) {
  const Icon = icon === undefined ? (kind === 'folder' ? FolderIcon : DatabaseIcon) : icon
  return (
    <div
      style={style}
      className="flex h-[var(--sidebar-tile-size)] items-center gap-2 overflow-hidden rounded-md bg-[color:var(--sidebar-submenu-item-bg)] pl-3 pr-[3px] text-sm font-medium text-[color:var(--sidebar-submenu-text-default)] shadow-lg ring-1 ring-[color:var(--sidebar-submenu-border)]"
    >
      {Icon ? (
        <Icon size={14} className="shrink-0 text-[color:var(--sidebar-submenu-text-faint)]" />
      ) : null}
      <span className="truncate">{label}</span>
    </div>
  )
}
